const MainSearch = class extends HTMLElement {
  constructor() {
    super();

    // Clicking close button
    this.querySelectorAll(".main-search__close").forEach((el) => {
      el.addEventListener("click", (evt) => {
        evt.preventDefault();
        this.closeSearch();
      });
    });

    this.querySelector(".main-search__icon").addEventListener("click", () => {
      this.querySelector(".main-search__input").value = "";
      this.closeSearch();
    });

    // Pressing escape key
    this.querySelector(".main-search__input").addEventListener(
      "keyup",
      (evt) => {
        if (evt.key === "Escape") {
          this.closeSearch();
        }
      }
    );

    // Clicking outside of search
    document.addEventListener("click", (evt) => {
      if (
        !this.contains(evt.target) &&
        !this.querySelector(".main-search__input").contains(evt.target)
      ) {
        this.closeSearch();
      }
    });

    // Search as you type
    if (this.dataset.quickSearch === "true") {
      this.initQuickSearch();
    }
  }

  closeSearch() {
    document.body.classList.remove("show-search");
    const resultsBox = this.querySelector(".main-search__results");
    resultsBox.style.display = "none";
    this.querySelector(".main-search__input").value = "";
    this.classList.remove("main-search--has-results");
    this.classList.remove("main-search--results-on-multiple-lines");
    this.classList.remove("main-search--no-results");
    this.classList.remove("main-search--loading");
  }

  initQuickSearch() {
    const searchInput = this.querySelector(".main-search__input");

    const searchTimeoutThrottle = 500;
    const resultLimit = 50;
    const includeMeta = this.dataset.quickSearchMeta === "true";
    let searchTimeoutID = -1;
    let searchAbortController = null;

    const handleInputChange = () => {
      const resultsBox = this.querySelector(".main-search__results");
      resultsBox.style.display = "block";
      const valueToSearch = searchInput.value;

      // Only search if search string longer than 2, and it has changed
      if (valueToSearch.length && valueToSearch !== this.oldSearchValue) {
        // Save previous value
        this.oldSearchValue = valueToSearch;

        // Kill outstanding ajax request
        if (searchAbortController !== null) {
          searchAbortController.abort("Existing request not needed");
          searchAbortController = null;
        }

        // Kill previous search
        clearTimeout(searchTimeoutID);

        // Create URL for full search results
        const form = searchInput.closest("form");
        const linkURL = new URL(form.action);
        const formParams = new URLSearchParams(new FormData(form));
        formParams.forEach((value, key) => {
          linkURL.searchParams.set(key, value);
        });

        // Show loading
        this.classList.remove(
          "main-search--has-results",
          "main-search--results-on-multiple-lines",
          "main-search--no-results"
        );
        this.classList.add("main-search--loading");
        if (!this.querySelector(".main-search__results-spinner")) {
          resultsBox.innerHTML =
            '<div class="main-search__results-spinner"><div class="loading-spinner"></div></div>';
        }

        // Do next search (in X milliseconds)
        searchTimeoutID = setTimeout(() => {
          searchAbortController = new AbortController();
          let ajaxUrl;

          if (theme.Shopify.features.predictiveSearch) {
            // use the API
            ajaxUrl = new URL(
              theme.routes.base + theme.routes.predictiveSearch
            );
            ajaxUrl.searchParams.set("q", valueToSearch);
            ajaxUrl.searchParams.set("section_id", "predictive-search");
            ajaxUrl.searchParams.set("resources[limit]", resultLimit);
            ajaxUrl.searchParams.set(
              "resources[options][fields]",
              includeMeta
                ? "title,product_type,variants.title,vendor,tag,variants.sku"
                : "title,product_type,variants.title,vendor"
            );
          } else {
            // use the theme template fallback
            ajaxUrl = new URL(linkURL);
            ajaxUrl.searchParams.set("section_id", "main-search");
          }

          fetch(ajaxUrl, {
            method: "get",
            signal: searchAbortController.signal,
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.text();
            })
            .then((response) => {
              const template = document.createElement("template");
              template.innerHTML = response;
              let resultsList = null;
              if (theme.Shopify.features.predictiveSearch) {
                resultsList = template.content.querySelector(".product-grid");
              } else {
                resultsList = template.content.querySelector(
                  ".section-search-template .product-grid"
                );
              }

              // reset previous contents
              searchAbortController = null;
              this.classList.remove(
                "main-search--has-results",
                "main-search--results-on-multiple-lines",
                "main-search--no-results"
              );
              resultsBox.innerHTML = "";

              const resultsProducts = document.createElement("div");
              resultsProducts.className =
                "main-search__results__products collection-listing";
              resultsProducts.innerHTML = "<div></div>";
              const resultsPages = document.createElement("div");
              resultsPages.className = "main-search__results__pages";

              resultsProducts.firstElementChild.className =
                resultsList.className;

              // Convert standard blocks into quick search result format
              resultsList
                .querySelectorAll(
                  ".product-block:not(.collection-block):not(.page-block)"
                )
                .forEach((block, index) => {
                  if (index <= resultLimit) {
                    block.classList.add("main-search-result");
                    block
                      .querySelectorAll(".btn.quickbuy-toggle")
                      .forEach((el) => el.remove());
                    block
                      .querySelectorAll(".quickbuy-toggle")
                      .forEach((el) => el.classList.remove("quickbuy-toggle"));
                    resultsProducts.firstElementChild.appendChild(block);
                  }
                });

              resultsList
                .querySelectorAll(".product-block.page-block")
                .forEach((block) => {
                  const item = document.createElement("a");
                  item.className =
                    "main-search-result main-search-result--page";
                  item.href = block.querySelector("a").href;
                  item.innerHTML =
                    '<div class="main-search-result__text"></div>';
                  item.firstElementChild.innerText =
                    block.querySelector(".page-block__title").innerText;
                  resultsPages.appendChild(item);
                });

              this.classList.remove("main-search--loading");

              const areProducts = !!resultsProducts.querySelector(
                ".main-search-result"
              );
              const arePages = !!resultsPages.querySelector(
                ".main-search-result"
              );

              // Count total search results
              const totalResults =
                (areProducts
                  ? resultsProducts.querySelectorAll(".main-search-result")
                      .length
                  : 0) +
                (arePages
                  ? resultsPages.querySelectorAll(".main-search-result").length
                  : 0);

              if (areProducts || arePages) {
                const totalResultsDiv = document.createElement("div");
                totalResultsDiv.className = "total-results";
                totalResultsDiv.innerHTML = `Rastų ${totalResults} rezultatų`;
                resultsBox.appendChild(totalResultsDiv);

                // Numerous results
                this.classList.add("main-search--has-results");
                this.classList.toggle(
                  "main-search--results-on-multiple-lines",
                  resultsProducts.querySelectorAll(".product-block").length > 4
                );
                if (areProducts) {
                  resultsBox.appendChild(resultsProducts);
                }
                // if (arePages) {
                //   const heading = document.createElement("h6");
                //   heading.className = "main-search-result__heading";
                //   heading.innerHTML = theme.strings.generalSearchPages;
                //   resultsPages.insertAdjacentElement("afterbegin", heading);
                //   resultsBox.appendChild(resultsPages);
                // }

                const iterationResults = document.querySelector(
                  ".main-search__results__products"
                );

                const allLink = document.createElement("a");
                allLink.className = "main-search__results-all-link";
                allLink.href = linkURL;
                allLink.innerHTML =
                  theme.strings.generalSearchViewAll +
                  `<svg style="margin-left: 8px" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 17.998C7.87827 17.998 5.84344 17.1552 4.34315 15.6549C2.84285 14.1546 2 12.1198 2 9.99805C2 7.87632 2.84285 5.84148 4.34315 4.34119C5.84344 2.8409 7.87827 1.99805 10 1.99805C12.1217 1.99805 14.1566 2.8409 15.6569 4.34119C17.1571 5.84148 18 7.87632 18 9.99805C18 12.1198 17.1571 14.1546 15.6569 15.6549C14.1566 17.1552 12.1217 17.998 10 17.998ZM12.851 7.14205C12.7575 7.0498 12.6314 6.99807 12.5 6.99805H7.5C7.36739 6.99805 7.24021 7.05073 7.14645 7.14449C7.05268 7.23826 7 7.36544 7 7.49805C7 7.63066 7.05268 7.75783 7.14645 7.8516C7.24021 7.94537 7.36739 7.99805 7.5 7.99805H11.293L7.146 12.144C7.05211 12.2379 6.99937 12.3653 6.99937 12.498C6.99937 12.6308 7.05211 12.7582 7.146 12.852C7.23989 12.9459 7.36722 12.9987 7.5 12.9987C7.63278 12.9987 7.76011 12.9459 7.854 12.852L12 8.70505V12.498C12 12.6307 12.0527 12.7578 12.1464 12.8516C12.2402 12.9454 12.3674 12.998 12.5 12.998C12.6326 12.998 12.7598 12.9454 12.8536 12.8516C12.9473 12.7578 13 12.6307 13 12.498V7.49805C13 7.36667 12.9482 7.24059 12.856 7.14705L12.851 7.14205Z" fill="#93AD90"/>
</svg>
`;
                iterationResults.appendChild(allLink);
              } else {
                // No results - show nothing
                this.classList.add("main-search--no-results");
                const emptyMessage = document.createElement("div");
                emptyMessage.className = "main-search__empty-message";
                emptyMessage.innerHTML =
                  theme.strings.generalSearchNoResultsWithoutTerms;
                resultsBox.appendChild(emptyMessage);
              }
            })
            .catch((error) => {
              console.warn(error);
            });
        }, searchTimeoutThrottle);
      } else if (!valueToSearch.length) {
        // Abandon current search
        this.oldSearchValue = valueToSearch;
        if (searchAbortController !== null) {
          searchAbortController.abort("Existing request not needed");
          searchAbortController = null;
        }
        clearTimeout(searchTimeoutID);

        // Clear results
        this.classList.remove(
          "main-search--has-results",
          "main-search--results-on-multiple-lines",
          "main-search--loading"
        );
        resultsBox.innerHTML = "";
        this.closeSearch();
      }
    };

    searchInput.addEventListener("keyup", handleInputChange.bind(this));
    searchInput.addEventListener("change", handleInputChange.bind(this));
  }
};

window.customElements.define("main-search", MainSearch);
